jQuery(document).ready(function($) {

    // loop through each achievement
    $('.score').each(function(index) {
        // get the score and goal values for this achievement
        const score = parseFloat($(this).text());
        const goal = parseFloat($('.goal').eq(index).text());

        // calculate the percentage of the difference between score and goal
        const percentage = Math.min(100, Math.max(0, (score / goal) * 100));

        // update the width of the progress bar
        $('.progress-bar').eq(index).css('width', `${percentage}%`);

    });

    $(document).on('click', '.single-border-reward', function(e) {
        //  console.log('clicked on single-border-reward');
        const $this = $(this);

        if ($this.hasClass('locked') || $this.hasClass('active')) {
            return;
        }

        $('.single-border-reward.active').removeClass('active');
        $this.addClass('active');

        const $border = $this.find('.border');
        const $clone = $border.clone();
        $clone.addClass('current_border');

        $('.current_border').replaceWith($clone);

        post_update_user_reward($this, 'user_avatar_border');
    });

    $(document).on('click', '.single-banner-reward', function(e) {
        if (!$(this).hasClass('locked')) {
            $('.single-banner-reward').removeClass('active');
            $(this).addClass('active');
            let src = $(this).find('img').attr('src');
            $('.customized-profile-header .banner').attr('src', src);
        }
        post_update_user_reward($(this), 'user_avatar_background');
    });

    function post_update_user_reward(item, object_type) {
        var id = item.data('id');
        var image = item.data('image');

        $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'GET',
                dataType: 'json',
                data: {
                    action: 'save_user_reward',
                    id: id,
                    image: image,
                    object_type: object_type,
                },
            })
            .done(function(data) {
                console.log(data);
                console.log('All done!');
                if (data.success === false) {
                    console.log('Error!');
                } else {
                    console.log('Success!');
                }
            })
            .fail(function(jqXHR, textStatus, errorThrown) {
                console.log('Error occured!');
            });
    }

    // show only 4 rewards

    function showFourRewards(reward, amount) {

        let elements = reward;
        let numToShow = amount;
        let showMoreButton = elements.next().filter('.show-more');
        if (elements.length > numToShow) {
            elements.filter(':gt(' + (numToShow - 1) + ')').hide();
        }

        showMoreButton.click(function() {

            if (showMoreButton.hasClass('show')) {
                elements.show();
                $(this).toggleClass('show');
                $(this).text('visa mindre');
            } else {
                elements.filter(':gt(' + (numToShow - 1) + ')').hide();
                $(this).text('visa fler');
                $(this).toggleClass('show');
            }
        });

    }

    showFourRewards($('.border-rewards'), 4);
    showFourRewards($('.banner-rewards'), 4);

    function showThreeAchievement(achievement) {

        let elements = achievement;
        let numToShow = 3;

        let showMoreButton = $('.preview-achievements .show-more');
        if (elements.length > numToShow) {
            elements.filter(':gt(' + (numToShow - 1) + ')').hide();
        }

        showMoreButton.click(function() {

            if (showMoreButton.hasClass('show')) {
                elements.show();
                $(this).toggleClass('show');
                $(this).text('visa mindre');
            } else {
                elements.filter(':gt(' + (numToShow - 1) + ')').hide();
                $(this).text('visa fler');
                $(this).toggleClass('show');
            }
        });

    }

    showThreeAchievement($('.personal-achievements .achievement'));

    /*  $('.single-border-reward').on('click', 'single-border-reward', function() {
     let user_avatar_border = $(this).data('border-image');

     // Send an AJAX request to update the custom field with the value of customField1
     $.ajax({
     type: 'POST',
     url: '/update-custom-field.php',
     data: {
     elementId: $(this).data('id'), // Replace with the ID of the element
     customField: 'user_avatar_border', // Replace with the name of the custom field to update
     value: user_avatar_border, // Replace with the value to update the custom field with
     },
     success: function(data) {
     console.log('Custom field updated');
     },
     });
     });*/
});


